<span class="group_title default__family-font">Select recipient</span>
<div class="recipient-scroll-container" class="ms-0 mt-1 p-0">
  <c11n-radio-group
    legendText="Select recipient"
    [hideLegend]="true"
    [hasError]="true"
    [hasCustomHintError]="true"
    [variant]="'tiles'"
  >
    <ng-container *ngFor="let recipient of recipients; trackBy: trackByRecipient">
      <div class="recipient-tile">
        <c11n-radio
          [labelText]="recipient.name + (recipient.addressPurposeDescription ? ' (' + recipient.addressPurposeDescription + ')' : '')"
          [descriptiveLabel]="recipient.address"
        >
          <input
            c11nRadioInput
            type="radio"
            name="recipient"
            [value]="recipient.id + '-' + recipient.name + '-' + recipient.address"
            [checked]="selectedRecipientKey === recipient.id + '-' + recipient.name + '-' + recipient.address"
            aria-describedby="recipient"
            (change)="onRecipientChange(recipient.id + '-' + recipient.name + '-' + recipient.address)"
          />
        </c11n-radio>
      </div>
    </ng-container>
  </c11n-radio-group>
</div>